module.exports = function(strings) {
  if (typeof strings === 'string') strings = [strings]
  var exprs = [].slice.call(arguments,1)
  var parts = []
  for (var i = 0; i < strings.length-1; i++) {
    parts.push(strings[i], exprs[i] || '')
  }
  parts.push(strings[i])
  return parts.join('')
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/glslify/browser.js
 ** module id = 243
 ** module chunks = 0
 **/